import { Typography } from "@mui/material";
import { DefaultCard, PageLayout } from "components";
import React from "react";

function StorePage() {
  return (
    <PageLayout>
      <DefaultCard title="STORE">
        <Typography variant="h4">Coming Soon</Typography>
      </DefaultCard>
    </PageLayout>
  );
}

export default StorePage;
